<template>
    <div>
        <!--<p @onLoad="logout">Logged out</p>-->
    </div>
</template>

<script>
    export default ({
        name: "Logout",
        methods: {
            logout() {
                this.$auth.logout({
                    returnTo: "https://gamedb.frlen.net"
                });
            }
        },
        created() {
            this.logout
        }
    });
</script>
